import Vue from 'vue';
const vueEventBus = new Vue();
export default vueEventBus;